// 9fbef606107a605d69c0edbcd8029e5d
import ReactDOMServer from 'react-dom/server';

const hasDocument = typeof document !== 'undefined';
const vendorEvents = [
  {
    hidden: 'hidden',
    event: 'visibilitychange',
    state: 'visibilityState',
  },
  {
    hidden: 'webkitHidden',
    event: 'webkitvisibilitychange',
    state: 'webkitVisibilityState',
  },
  {
    hidden: 'mozHidden',
    event: 'mozvisibilitychange',
    state: 'mozVisibilityState',
  },
  {
    hidden: 'msHidden',
    event: 'msvisibilitychange',
    state: 'msVisibilityState',
  },
  {
    hidden: 'oHidden',
    event: 'ovisibilitychange',
    state: 'oVisibilityState',
  },
];

export const isSupported = hasDocument && Boolean(document.addEventListener);

export const visibility = (() => {
  if (!isSupported) {
    return null;
  }

  let eventToReturn = null;

  for (let i = 0; i < vendorEvents.length; i += 1) {
    if (vendorEvents[i].hidden in document) {
      eventToReturn = vendorEvents[i];
    }
  }

  // otherwise it's not supported
  return eventToReturn;
})();

export const getHandlerArgs = () => {
  if (!visibility) {
    return [true, 'visible'];
  }
  const { hidden, state } = visibility;
  return [!document[hidden], document[state]];
};

/**
 * @description Converts react element or HTML Element to plain string.
 * @param {string | ReactNode | HTMLElement} input
 * @returns {string}
 */
export function toPlainString(input) {
  if (typeof input === 'string') {
    return input; // already plain text
  }

  if (input instanceof HTMLElement) {
    return input.innerText || input.textContent || '';
  }

  if (input) {
    // React element → HTML → plain text
    const htmlString = ReactDOMServer.renderToStaticMarkup(input);
    const temp = document.createElement('div');
    temp.innerHTML = htmlString;
    return temp.textContent || temp.innerText || '';
  }

  return '';
}
